import { isStaging } from "@/webflow/is-staging";
import { onDestroy } from "./_";
import gsap, { ScrollTrigger } from "@lib/gsap";
export default function (element, dataset) {
  let lines = {
    top: element.querySelector(".s-lines_top"),
    horizontal: element.querySelector(".s-lines_horizontal"),
    bottom: element.querySelector(".s-lines_bottom"),
  };

  let tl = gsap.timeline({
    scrollTrigger: {
      trigger: element,
      start: "top 70%",
      end: "top 50%",
      scrub: true,
      markers: isStaging,
    },
    defaults: {
      ease: "none",
    },
  });

  tl.from(lines.top, {
    scaleY: 0,
  });
  tl.from(lines.horizontal, {
    scaleX: 0,
  });
  tl.from(lines.bottom, {
    scaleY: 0,
  });

  onDestroy(() => {
    tl.kill();
  });
}
